(function(){

  /**
   * initializeBlock
   *
   * Adds custom JavaScript to the block HTML.
   *
   * @date    15/4/19
   * @since   1.0.0
   *
   * @param   object $block The block jQuery element.
   * @param   object attributes The block attributes (only available when editing).
   * @return  void
   */

  let sliders = []
  
  const options = {
    type: 'fade',
    pagination: false,
    arrows: true,
    arrowPath: 'm13.6856454 3 14.2832992 15.8554567 1.0310554 1.1445433-1.0310554 1.1445433-14.2832992 15.8554567-2.6856454-2.2890866 13.2515234-14.7121955-13.2515234-14.70963133z',
    perPage: 1,
    perMove: 1,
    speed: 1200,
    easing: 'ease'
  }

  const initializeBlock = function( $block ) {
    
    const sliderElement = $block[0].querySelector( '.splide' )

    sliders.forEach( ( item, index ) => {
      if ( item[0] === sliderElement ) {
        item[1].destroy()
        delete sliders[index]
      }
    } )

    const slider = new Splide( sliderElement, options ).mount()
    sliders.push( [ sliderElement, slider ] )

  }

  // Frontend only
  if ( !window.acf ) {
    document.querySelectorAll('.splide').forEach( slider => { new Splide( slider, options ).mount() } )
  }

  // Backend only
  if ( window.acf ) {
    window.acf.addAction( 'render_block_preview/type=apm/image-slider', initializeBlock );
  }

})();